import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SalesOrders_ds_get_hardallocationdetails_by_hardallocationIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { hardallocationId: number }): 
  Promise<{ result: { Id?: number, HardAllocationId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.hardallocationId)) {
      missingRequiredInParams.push('\'hardallocationId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SalesOrders/datasources/ds_get_hardallocationdetails_by_hardallocationId/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { hardallocationId: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, HardAllocationId?: number }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.hardallocationId)) {
      missingRequiredInParams.push('\'hardallocationId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SalesOrders/datasources/ds_get_hardallocationdetails_by_hardallocationId/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { hardallocationId: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, HardAllocationId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.hardallocationId)) {
      missingRequiredInParams.push('\'hardallocationId\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SalesOrders/datasources/ds_get_hardallocationdetails_by_hardallocationId/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      hardallocationId: number    }) {
        if(isNil(inParams.hardallocationId)) {
          return true; 
        }
      return false;
    }
}
